/* eslint-disable arrow-parens */
import {
  FETCH_COUNTRY,
  FETCH_INTEREST,
  SET_CARDS,
  SET_HIDE_LOCK_ROOM,
  SET_LOADING,
} from './commonTypes'
import { getCountry, getInterest, listCards } from '@/utils/apiEndpoints'

export const setLoading = (payload) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: payload })
}
export const fetchCountries = () => async (dispatch) => {
  try {
    const countries = await getCountry()
    dispatch({ type: FETCH_COUNTRY, payload: countries.result.data })
  } catch (error) {
    dispatch({ type: FETCH_COUNTRY, payload: false })
  }
}

export const fetchInterests = () => async (dispatch) => {
  try {
    const interests = await getInterest()
    dispatch({ type: FETCH_INTEREST, payload: interests.result.data })
  } catch (error) {
    dispatch({ type: FETCH_INTEREST, payload: false })
  }
}

export const setAssets = (assets) => async (dispatch) => {
  dispatch({ type: FETCH_INTEREST, payload: assets })
}

export const setCards = (stripeCustomerId) => async (dispatch) => {
  try {
    const resp = await listCards(stripeCustomerId)
    dispatch({
      type: SET_CARDS,
      payload: resp.result,
    })
  } catch (error) {
    dispatch({
      type: SET_CARDS,
      payload: [],
    })
  }
}

export const setHideLockRoom = (hideConfirmation) => async (dispatch) => {
  dispatch({ type: SET_HIDE_LOCK_ROOM, payload: hideConfirmation })
}
